import { render, staticRenderFns } from "./copyUrl.vue?vue&type=template&id=20984941&scoped=true&"
import script from "./copyUrl.vue?vue&type=script&lang=js&"
export * from "./copyUrl.vue?vue&type=script&lang=js&"
import style0 from "./copyUrl.vue?vue&type=style&index=0&id=20984941&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20984941",
  null
  
)

export default component.exports